import React,{createContext} from 'react';


const Player = {
    player: false,
    currPost: null,
}

export const PlayerContext = createContext(Player);
